<template>
  <div
    class="editor-pane"
    @click="handleClickCanvas"
    @keyup.esc="handleKeyup"
    ref="editorPane"
  >
    <div class="editor-pane-inner" ref="editorPaneInner">
      <div
        class="editor-main"
        :style="{
          transform: 'scale(' + scale + ')',
          width: projectData.width + 'px',
          height: projectData.height + 'px',
        }"
        @click.stop.prevent="() => {}"
      >
        <div class="dynamic-panel-wrapper" v-if="activeDynamicPanelUUID">
          <div class="dynamic-panel-header">
            <div class="dynamic-panel-center">
              <span>(动态面板): </span>
              <el-dropdown trigger="click" size="small" v-if="activeDynamicPanelState && activeDynamicPanel.states">
                <span class="el-dropdown-link dynamic-panel-state">
                  {{activeDynamicPanelState.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-full-screen" v-for="(i, k) in activeDynamicPanel.states" :key="k">
                    <span :class="{'colorActive': activeDynamicPanelStateUUID == i.uuid}" @click="stateSet(i)">{{ i.name }}</span>
                    <i class="el-icon-setting" @click.stop.prevent="stateChangeName(i)" :style="{marginLeft: '10px'}"></i>
                    <i class="el-icon-document-copy" @click.stop.prevent="stateCopy(i)"></i>
                    <i class="el-icon-delete" @click.stop.prevent="stateDel(i)"></i>
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-plus"><span @click.stop.prevent="stateAdd">添加状态</span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="dynamic-panel-close" @click.stop.prevent="dynamicPanelClose">
              <!-- <span>关闭</span> -->
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="dynamic-panel-viewport" :style="
            getCommonStyle({
              ...activeDynamicPanel.commonStyle,
              ...getActiveDynamicPanelComputedStyle(),
              background: '#fff',
              border: '1px dashed rgba(0, 127, 201, 1)',
              zIndex: 0,
            })
          ">
            <edit-shape-group
              v-if="activeElementGroupUUID"
              ref="editShapeGroup"
              :scale="scale"
              @manageRefresh="manageRefresh"
              @handleElementClick="(data) => handleElementClick(data.uuid)"
              @resize="handleElementResize"
            ></edit-shape-group>
            <!--页面组件列表展示-->
            <edit-shape
              v-for="item in activePageElementsInDynamicPanel"
              :key="item.uuid"
              :uuid="item.uuid"
              :scale="scale"
              :item="item"
              :defaultStyle="item.commonStyle"
              :style="
                getCommonStyle(checkGroupDisplay(item, {
                  width: item.commonStyle.width,
                  height: item.commonStyle.height,
                  left: item.commonStyle.left,
                  top: item.commonStyle.top,
                  position: item.commonStyle.position,
                }))
              "
              @handleElementClick="handleElementClick(item.uuid)"
              @handleEditShapeGroupMouseDown="handleEditShapeGroupMouseDown"
              @resize="handleElementResize"
              @manageRefresh="manageRefresh"
              :active="
                (item.uuid === activeElementUUID ||
                  activeElementUUIDMore.includes(item.uuid)) &&
                !activeElementGroupUUID
              "
            >
              <component
                :style="
                  getCommonStyle({
                    ...(item.isHotZone
                      ? { ...item.commonStyle, background: 'rgba(255,255,0,0.1)' } :
                      item.isDynamicPanel
                      ? { ...item.commonStyle, background: 'rgba(0, 127, 201, 0.3)' }
                      : item.commonStyle),
                    top: 0,
                    left: 0,
                  })
                "
                :is="item.elName"
                class="element-on-edit-pane"
                v-bind="item.propsValue"
              >
                <dynamic-panel-self v-if="item.isDynamicPanel" :item="item"></dynamic-panel-self>
              </component>
            </edit-shape>
          </div>
        </div>
        <div
          class="page-preview-wrapper"
          ref="canvas-panel"
          id="canvas-panel"
          :style="getCommonStyle(activePage.commonStyle)"
        >
          <edit-shape-group
            v-if="activeElementGroupUUID && !activeDynamicPanelUUID"
            ref="editShapeGroup"
            :scale="scale"
            @manageRefresh="manageRefresh"
            @handleElementClick="(data) => handleElementClick(data.uuid)"
            @resize="handleElementResize"
          ></edit-shape-group>
          <!--页面组件列表展示-->
          <edit-shape
            v-for="item in activePageElementsOutDynamicPanel"
            :key="item.uuid"
            :uuid="item.uuid"
            :scale="scale"
            :item="item"
            :defaultStyle="item.commonStyle"
            :style="
              getCommonStyle(checkGroupDisplay(item, {
                width: item.commonStyle.width,
                height: item.commonStyle.height,
                left: item.commonStyle.left,
                top: item.commonStyle.top,
                position: item.commonStyle.position,
              }))
            "
            @handleElementClick="handleElementClick(item.uuid)"
            @handleEditShapeGroupMouseDown="handleEditShapeGroupMouseDown"
            @resize="handleElementResize"
            @manageRefresh="manageRefresh"
            :active="
              (item.uuid === activeElementUUID ||
                activeElementUUIDMore.includes(item.uuid)) &&
              !activeElementGroupUUID && !activeDynamicPanelUUID
            "
          >
            <component
              :style="
                getCommonStyle({
                  ...(item.isHotZone
                    ? { ...item.commonStyle, background: 'rgba(255,255,0,0.1)' } :
                    item.isDynamicPanel
                    ? { ...item.commonStyle, background: 'rgba(0, 127, 201, 0.3)' }
                    : item.commonStyle),
                  top: 0,
                  left: 0,
                })
              "
              :is="item.elName"
              class="element-on-edit-pane"
              v-bind="item.propsValue"
            >
              <dynamic-panel-self v-if="item.isDynamicPanel" :item="item"></dynamic-panel-self>
            </component>
          </edit-shape>
        </div>
        <div class="page-wrapper-mask"></div>
      </div>

      <div
        class="page-wrapper-menu-operation menu-item-on-edit-panel"
        :style="getMenuOptionsPositionStyle"
        :class="{ active: activeElementUUID }"
      >
        <el-tooltip
          v-for="(item, index) in activeElementGroupUUID?groupOptions:menuOptions"
          :key="index"
          effect="dark"
          :content="item.title"
          placement="right"
        >
          <div
            class="menu-item menu-item-on-edit-panel"
            @click="handleElementCommand(item.value)"
          >
            <i class="menu-item-on-edit-panel" :class="[item.icon]"></i>
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { _qk_register_components_object } from "@client/plugins/index";
import editShape from "@/components/edit-shape";
import editShapeGroup from "@/components/edit-shape-group";
import dynamicPanelSelf from "@/components/dynamic-panel-self";
import editorProjectConfig from "@client/pages/editor/DataModel";
import { mapState, mapGetters } from "vuex";
import html2canvas from "html2canvas";

// todo 测试用
window._qk_register_components_object = _qk_register_components_object;
export default {
  props: {
    // canvas画板缩放
    scale: {
      type: Number,
      default: 1,
    },
  },
  components: {
    // 批量注册qk组件
    ..._qk_register_components_object,
    // 画板组件
    [editShape.name]: editShape,
    [editShapeGroup.name]: editShapeGroup,
    [dynamicPanelSelf.name]: dynamicPanelSelf,
  },
  data() {
    return {
      getCommonStyle: editorProjectConfig.getCommonStyle,
      groupOptions: [],
      menuOptions: [
        {
          title: "复制",
          icon: "iconfont iconfuzhi",
          value: "copy",
        },
        {
          title: "删除",
          icon: "iconfont iconshanchu",
          value: "delete",
        },
        {
          title: "字体放大",
          icon: "iconfont iconzitifangda",
          value: "fontA+",
        },
        {
          title: "字体缩小",
          icon: "iconfont iconzitisuoxiao",
          value: "fontA-",
        },
        {
          title: "字体加粗",
          icon: "iconfont iconzitijiacu",
          value: "fontB",
        },
        {
          title: "图层上移",
          icon: "iconfont iconziyuan1",
          value: "layerUp",
        },
        {
          title: "图层下移",
          icon: "iconfont iconxiayiyiceng",
          value: "layerDown",
        },
        {
          title: "图层置顶",
          icon: "iconfont iconcontrol-top",
          value: "layerTop",
        },
        {
          title: "图层置底",
          icon: "iconfont iconcontrol-bottom",
          value: "layerBottom",
        },
      ],
      editorPaneWidth: 0,
      isHoldingCtrl: false,
      isHoldingAlt: false,
    };
  },
  computed: {
    ...mapState({
      projectData: (state) => state.editor.projectData,
      activePageUUID: (state) => state.editor.activePageUUID,
      activeElementUUID: (state) => state.editor.activeElementUUID,
      activeElementUUIDMore: (state) => state.editor.activeElementUUIDMore,
      activeElementGroupUUID: (state) => state.editor.activeElementGroupUUID,
      activeDynamicPanelUUID: (state) => state.editor.activeDynamicPanelUUID,
      activeDynamicPanelStateUUID: (state) => state.editor.activeDynamicPanelStateUUID,
    }),
    ...mapGetters([
      "currentPageIndex",
      "activeElementIndex",
      "activeElement",
      "activePage",
      "activeDynamicPanel",
      "activeDynamicPanelState",
    ]),
    activePageElementsInDynamicPanel(){
      return this.activePage.elements.filter((i)=>i.dynamicPanelUUID == this.activeDynamicPanelUUID && i.dynamicPanelStateUUID == this.activeDynamicPanelStateUUID);
    },
    activePageElementsOutDynamicPanel(){
      return this.activePage.elements.filter((i)=>!i.dynamicPanelUUID);
    },
    getMenuOptionsPositionStyle() {
      let both =
        (this.editorPaneWidth - this.projectData.width * this.scale) / 2;
      let right = both < 60 ? 16 : both;
      return {
        right: right + "px",
      };
    },
  },
  mounted() {
    this.editorPaneWidth = this.$refs.editorPane.offsetHeight;
    document.addEventListener("keydown", this.keydownHandler);
    document.addEventListener("keyup", this.keyupHandler);
    this.$refs['editorPaneInner'].scrollLeft = 350;
    setTimeout(() => {
      this.$store.dispatch("addHistoryCache");
    }, 300);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keydownHandler);
    document.removeEventListener("keyup", this.keyupHandler);
  },
  methods: {
    getActiveDynamicPanelComputedStyle(){
      let totalLeft = 0, totalTop = 0
      const getParentDynamicPanelStyle = (uuid)=>{
        const elem = this.activePage.elements.find((i)=>i.uuid == uuid)
        if(elem){
          totalLeft += elem.commonStyle.left;
          totalTop += elem.commonStyle.top;
        }
        if(elem.dynamicPanelUUID){
          return getParentDynamicPanelStyle(elem.dynamicPanelUUID)
        }
        return {
          left: totalLeft,
          top: totalTop,
        }
      }
      return getParentDynamicPanelStyle(this.activeDynamicPanel.uuid)
    },
    dynamicPanelClose(){
      const dynamicPanelUUID = this.activeDynamicPanelUUID + '';
      this.$store.dispatch('setActiveDynamicPanelUUID', '')
      this.$store.dispatch('setActiveDynamicPanelStateUUID', '')
      this.$store.dispatch('setActiveElementGroupUUID', '')
      this.$store.dispatch('setActiveElementUUIDMore', '')
      if(this.activeElement.dynamicPanelUUID == dynamicPanelUUID){
        this.$store.dispatch('setActiveElementUUID', dynamicPanelUUID)
      }
      if(this.activeElement.isDynamicPanel && this.activeElement.dynamicPanelUUID && this.activeElement.uuid == dynamicPanelUUID){
        this.$store.dispatch('setActiveElementUUID', this.activeElement.uuid)
      }
    },
    manageRefresh(){
      this.$nextTick(()=>{
        this.$emit('manageRefresh')
      })
    },
    stateSet(state){
      this.$store.dispatch("setActiveDynamicPanelStateUUID", state.uuid);
      this.manageRefresh();
    },
    stateCopy(item){
      this.$store.dispatch("copyDynamicPanelState", item.uuid)
      this.manageRefresh();
    },
    stateChangeName(item){
      this.$prompt(`给${item.name}重命名`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        if(value){
          const statesIndex = this.activeDynamicPanel.states.findIndex((i)=>i.uuid == item.uuid)
          this.activeDynamicPanel.states[statesIndex].name = value;
        }
      }).catch(() => {});
    },
    stateDel(state){
      this.$store.dispatch("deleteDynamicPanelState", state.uuid)
      this.manageRefresh();
    },
    stateAdd(){
      this.$store.dispatch("addDynamicPanelState");
      this.manageRefresh();
    },
    checkGroupDisplay(item, data){
      const elementGroups = this.activePage.elementGroups
      if(elementGroups){
        let elementInnerIndex = -1, elementGroupsIndex = -1;
        for(let i = 0; i < elementGroups.length; i++){
          for(let m = 0; m < elementGroups[i].list.length; m++){
            if(elementGroups[i].list[m] == item.uuid){
              elementGroupsIndex = i;
              elementInnerIndex = m;
              break;
            }
          }
        }
        if(elementGroupsIndex > -1 && elementInnerIndex > -1){
          return {
            ...data,
            display: elementGroups[elementGroupsIndex].display
          }
        }
      }
      return data;
    },
    handleEditShapeGroupMouseDown(e) {
      this.$refs["editShapeGroup"].handleMouseDownOnElement(e);
    },
    keydownHandler(e) {
      console.log(e.keyCode);
      if (e.keyCode == 18 || e.keyCode == 91) {
        this.isHoldingAlt = true;
      }else if (e.keyCode == 17) {
        this.isHoldingCtrl = true;
      }else if(e.keyCode == 66 && this.isHoldingCtrl){
        // ctrl+b 复制
        if(this.activeElementGroupUUID){
          this.$store.dispatch("copyElementGroups", {})
        }else{
          this.$store.dispatch("copyElement", {})
        }
        this.$nextTick(()=>{
          this.$emit('manageRefresh')
        })
      }else if(e.keyCode == 90 && this.isHoldingCtrl){
        // ctrl+z 撤销
        this.$store.dispatch("editorUndo")
      }else if(e.keyCode == 46){
        // delete 删除
        this.$store.dispatch("deleteElement")
        this.$nextTick(()=>{
          this.$emit('manageRefresh')
        })
      }
    },
    keyupHandler(e) {
      if (e.keyCode == 18 || e.keyCode == 91) {
        this.isHoldingAlt = false;
      }else if(e.keyCode == 17){
        this.isHoldingCtrl = false;
      }
    },
    /**
     * 元素被点击
     * @param uuid
     */
    handleElementClick(uuid) {
      const elemClickInit = () => {
        let groupIndex = -1,
          originGroupIndex = -1;
        this.activePage.elementGroups &&
          this.activePage.elementGroups.map((i, k) => {
            if (i.list.find((m) => m == uuid)) {
              groupIndex = k;
            }
            if (
              this.activeElementUUID &&
              i.list.find((m) => m == this.activeElementUUID)
            ) {
              originGroupIndex = k;
            }
          });
        this.$store.dispatch("setActiveElementGroupUUID", "");
        if (
          groupIndex > -1 &&
          uuid != this.activeElementUUID &&
          originGroupIndex != groupIndex
        ) {
          // 已有群组且非同组，则不让复选
          this.activePage.elementGroups[groupIndex].list.map((i) => {
            this.$store.dispatch("setActiveElementUUIDMore", i);
          });
          this.$store.dispatch("setActiveElementUUID", uuid);
          this.$store.dispatch(
            "setActiveElementGroupUUID",
            this.activePage.elementGroups[groupIndex].uuid
          );
        } else {
          // 未有群组，才可复选
          if (this.isHoldingAlt) {
            if (this.activeElementUUID && this.activeElementUUID != uuid) {
              this.$store.dispatch(
                "setActiveElementUUIDMore",
                this.activeElementUUID
              );
            }
            this.$store.dispatch("setActiveElementUUIDMore", uuid);
          } else {
            this.$store.dispatch("setActiveElementUUIDMore", "");
          }
          this.$store.dispatch("setActiveElementUUID", uuid);
        }
      };
      if (!this.activeElementUUID) {
        // 若尚未选择元件，则优先判断元件是否已在群组中，是则选中群组及复选组内元素，否则单选元件
        elemClickInit();
      } else {
        // 若已选择了元件，则优先判断是否已选择了群组
        if (this.activeElementGroupUUID) {
          // 若已选择群组，则判断欲选择的元件是否在群组中
          if (
            this.activePage.elementGroups
              .find((i) => i.uuid == this.activeElementGroupUUID)
              .list.find((i) => i == uuid)
          ) {
            // 在群组中，则取消群组，直接选中群组中的元素
            this.$store.dispatch("setActiveElementGroupUUID", "");
            this.$store.dispatch("setActiveElementUUIDMore", "");
            this.$store.dispatch("setActiveElementUUID", uuid);
          } else {
            // 不在群组中
            elemClickInit();
          }
        } else {
          // 未选择群组
          elemClickInit();
        }
      }
    },
    /**
     * 移动改变元素大小定位
     * @param pos 当pos有值表示移动中需要实时同步样式变化，pos为undefind时则表示移动结束，记一次历史纪录
     * 鼠标移动完成时才记入历史纪录
     */
    handleElementResize(pos) {
      if (!pos) {
        this.$store.dispatch("addHistoryCache");
        return;
      }
      // this.projectData.pages[this.currentPageIndex].elements[
      //   this.activeElementIndex
      // ].commonStyle.left = pos.left;
      // this.projectData.pages[this.currentPageIndex].elements[
      //   this.activeElementIndex
      // ].commonStyle.top = pos.top;
      // 更新元素commonStyle
      // this.projectData.pages[this.currentPageIndex].elements[
      //   this.activeElementIndex
      // ].commonStyle = {
      //   ...pos,
      // };
    },
    handleClickCanvas(e) {
      if (
        !e.target.classList.contains("element-on-edit-pane") &&
        !e.target.classList.contains("menu-item-on-edit-panel")
      ) {
        this.$store.dispatch("setActiveElementUUID", "");
        this.$store.dispatch("setActiveElementUUIDMore", "");
        this.$store.dispatch("setActiveElementGroupUUID", "");
        this.isHoldingAlt = false;
        this.isHoldingCtrl = false;
        console.log(e.target.classList, "handleClickCanvas!!!");
      }
    },
    /**
     * 对元素进行操作命令
     */
    handleElementCommand(command) {
      this.$store.dispatch("elementCommand", { command });
      this.manageRefresh();
    },
    /**
     * 监听键盘事件
     * @param e
     */
    handleKeyup(e) {
      console.log(1111, e);
    },
    /**
     * 提供截屏作为项目主图
     */
    screenshots() {
      const el = document.querySelector("#canvas-panel");
      html2canvas(el, {
        width: 375,
        height: 667,
        proxy: "/htmltocanvas/corsproxy", // 设置跨域接口
      }).then((canvas) => {
        let url = canvas.toDataURL("image/jpeg");
        this.$store.commit("updateCoverImage", url);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.editor-pane {
  height: 100%;
  width: 100%;
  border: 1px solid #ffffff;
  border-width: 0 1px;
  // background-image: linear-gradient(45deg, #f5f5f5 25%, transparent 0, transparent 75%, #f5f5f5 0), linear-gradient(45deg, #f5f5f5 25%, transparent 0, transparent 75%, #f5f5f5 0);
  background: #12152e;
  background-position: 0 0, 13px 13px;
  background-size: 26px 26px;
  display: flex;
  justify-content: center;
}

.editor-pane-inner {
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 20px;
}

.editor-main {
  border-radius: 3px;
  box-shadow: 0 3px 10px #dcdcdc;
  margin: 25px auto;
  position: relative;
  background: rgb(221, 221, 221);
  transform-origin: center top;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZAgMAAAC5h23wAAAAAXNSR0IB2cksfwAAAAlQTFRF9fX18PDwAAAABQ8/pgAAAAN0Uk5T/yIA41y2EwAAABhJREFUeJxjYIAC0VAQcGCQWgUCDUONBgDH8Fwzu33LswAAAABJRU5ErkJggg==");
}
.colorActive {
  color: rgba(0, 127, 201, 1);
}

.dynamic-panel-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(241, 241, 241, 0.7);
  z-index: 999;
  box-sizing: border-box;
  border: 4px solid rgba(0, 127, 201, 0.8);
  .dynamic-panel-header {
    width: 100%;
    height: 40px;
    left: 0;
    top: 0;
    background: rgba(0, 127, 201, 0.8);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 24px;
    .dynamic-panel-state {
      color: #fff;
      font-size: 24px;
      cursor: pointer;
      &:hover {
        text-decoration:underline;
      }
    }
    .dynamic-panel-close {
      top: 0;
      height: 40px;
      line-height: 40px;
      right: 20px;
      position: absolute;
      cursor: pointer;
      span {
        margin-right: 10px;
      }
    }
  }
}

.page-preview-wrapper {
  height: 100%;
  position: relative;
}

.page-wrapper-mask {
  height: 100%;
  width: 100%;
  z-index: 1000;
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  outline: rgba(236, 238, 240, 0.2) solid 10000px;
  display: none;
}

.element-on-edit-pane {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.page-wrapper-menu-operation {
  position: absolute;
  right: 0;
  top: 45px;
  width: 0;
  background: #1f2353;
  color: #fff;
  text-align: center;
  z-index: 1002;
  border-radius: 4px;
  display: none;
  transition: all 0.28s;
  opacity: 0;
  .menu-item {
    padding: 10px;
    cursor: pointer;
    &.i {
      font-size: 24px;
      line-height: 30px;
    }
    &:hover {
      background: rgba(37, 165, 137, 0.09);
      color: $primary;
      &.i {
        font-weight: bold;
        font-size: 26px;
      }
    }
  }
  &.active {
    display: block;
    width: 60px;
    opacity: 1;
  }
}
</style>
